export enum MigrationCode {
  Conversation = 'migration.conversation',
}
